// src/pages/StatisticsPage.js
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyStatisticsView from '../components/property/PropertyStatisticsView';
import './StatisticsPage.css';

const StatisticsPage = () => {
  const navigate = useNavigate();
  const tableWrapperRef = useRef(null);

  // This handler will be passed to the statistics view.
  // When a property is clicked, it will navigate to the properties page
  // with the property's ID as a query parameter.
  const handlePropertySelect = (property) => {
    if (property && property.propertyID) {
      navigate(`/properties?view=my&propertyId=${property.propertyID}`);
    }
  };

  return (
    <div className="stats-page-container">
      <h1>My Property Statistics</h1>
      <div className="stats-table-wrapper" ref={tableWrapperRef}>
        <PropertyStatisticsView onPropertySelect={handlePropertySelect} scrollContainerRef={tableWrapperRef} />
      </div>
    </div>
  );
};

export default StatisticsPage;
